
import {
  getDeliveryProductByHandle,
  invokeShopifyQuery,
} from "~/utils/shopify";
import FormatMixin from "~/mixin/format-mixin";
import ProductMapMixin from "~/mixin/product-map-mixin";
import ShopifyVariant from "~/types/shopify/ShopifyVariant";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import ProcessLineItemsMixin from "~/mixin/process-lineitems-mixin";
import { butter } from "~/plugins/buttercms";

const datadogErrorUrl = "datadog/events/error";
export default {
  name: "cal-delivery-window",
  data() {
    return {
      deliveryWindows: [] as {
        deliveryRegion: string;
        regionCode?: string | undefined;
        title: string;
        timeView: string;
        selected: boolean;
        price: string;
        productVariant?: ShopifyVariant | undefined;
        toggleYes?: string | undefined;
        textCommunicationLang?: string | undefined;
        startDeliveryDate?: string | undefined;
        endDeliveryDate?: string | undefined;
        pullDate?: string | undefined;
        ratePerDelivery?: string | undefined;
      }[],
      shopifyDeliveryWindows: [] as any,
      deliveryWindowSelected: { ...this.$store.state.cartItem.deliveryWindow },
      contactDetails: { ...this.$store.state.cartItem.contactDetails },
      product: this.$store.state.cartItem.product,
      deliveryRatesLoadingState: {
        loading: false,
        success: false,
        fail: false,
      },
      isCBCSKuCanadaWide: false,
      showLanguageChoice: false,
      isSameDayDelivery: false,
      deliveryWindowPara: "",
      isSameAddressOrder: false,
      pageData: {},
      deliveryWindowRegionalPara: "",
      postalCode: "",
      showError: false
    };
  },
  mixins: [
    ProductMapMixin,
    DeliveryWeekMixin,
    FormatMixin,
    ProcessLineItemsMixin,
  ],
  props: {
    subscriptionTimePeriod: {
      type: Number,
      required: false,
      default: 1, // except subscription 3 or 6, for all other this should be 1
    },
    workflow: {
      type: String,
      required: false,
    },
    config: {
      type: Object,
      required: false,
    },
    isOngoing: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
    sortedDeliveryWindows() {
    const priorityOrder = [
      "9am - 11am",
      "9am - 3pm",
      "3pm - 6pm",
      "9am - 6pm"
    ];

    return [...this.deliveryWindows].sort((a, b) => {
      const aTime = priorityOrder.findIndex(p => a.timeView.includes(p));
      const bTime = priorityOrder.findIndex(p => b.timeView.includes(p));
      return aTime - bTime;
    });
  }
  },
  async created() {
    this.$nuxt.$emit("deliveryWindowDisabled", true);
    this.validateContactDetails();
    this.deliveryWindowPara = (await this.getDeliveryWindowPara()).toString();
    this.isSameAddressOrder =
      this.$store.state.cartItem.sameDayDelivery.isSameAddressOrder;
    this.$nuxt.$on("postalCodeUpdated", async (postalCode: string) => {
      this.resetDeliveryWindow();
      this.postalCode = postalCode;
      await this.setUpDeliveryWindows();
    });
    this.$nuxt.$on("addressTypeUpdated", async () => {
      this.deliveryWindowPara = (await this.getDeliveryWindowPara()).toString();
    });
    this.$nuxt.$on("subQuantityUpdated", async () => {
      await this.setUpDeliveryWindows();
    });

    this.$nuxt.$on("toggleSameAddressOrder", async () => {
      this.isSameAddressOrder =
        this.$store.state.cartItem.sameDayDelivery.isSameAddressOrder;
        this.resetDeliveryWindow();
        await this.setUpDeliveryWindows();

    });

    this.$nuxt.$on("cityUpdated", async () => {
      this.$store.dispatch("cartItem/RECIPIENT_REMOVE", { ...this.recipient });
      this.resetDeliveryWindow();
    });

    this.$nuxt.$on("deliveryDateUpdated", async () => {
      this.$store.dispatch("cartItem/RECIPIENT_REMOVE", { ...this.recipient });
      this.resetDeliveryWindow();
    });
    this.$nuxt.$on("scrollToDeliveryWindow", () => {
      const deliveryWindowEl = document.getElementById("delivery-window");
      if (deliveryWindowEl) {
        deliveryWindowEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
    this.$nuxt.$on("firstNameUpdated", () => {
      this.contactDetails.name = this.$store.state.cartItem.recipient.firstName;
      this.contactDetails = JSON.parse(JSON.stringify(this.contactDetails));
    });
    this.$nuxt.$on("runInputFieldsValidation", () => {
      if (JSON.stringify(this.deliveryWindowSelected) === "{}") {
        this.showError = true;
      } else {
        this.showError = false;
      }
    })
  },
  watch: {
    deliveryWindowSelected() {
      this.validateContactDetails();
    },
    "contactDetails.name"() {
      this.validateContactDetails();
    },
    "contactDetails.phone"() {
      this.validateContactDetails();
    },
    "contactDetails.toggleYes"() {
      this.validateContactDetails();
    },
    "contactDetails.textCommunicationLang"() {
      this.validateContactDetails();
    },
  },
  methods: {
    scrollToRecipientDetails() {
      this.$nuxt.$emit("scrollToRecipientDetails");
    },
    resetDeliveryWindow() {
      this.deliveryWindowSelected = {};
      this.$store.dispatch("cartItem/DELIVERY_WINDOW_ADD", {});
    },
    onDeliveryWindowSelect(selectedItem: any) {
      this.showError = false;
      selectedItem.deliveryDate = this.$store.state.cartItem.deliveryDate || sessionStorage.deliveryDate;

      this.$store.dispatch("cartItem/DELIVERY_WINDOW_ADD", { ...selectedItem });
      this.deliveryWindowSelected = selectedItem;
    },
    validateContactDetails() {
      const { name, phone, toggleYes, textCommunicationLang } =
        this.contactDetails;
      const isPhoneValid = this.isPhoneNumberValid(phone);

      // format the contact number is it's valid
      if (isPhoneValid) {
        this.contactDetails.phone = this.formatPhoneNumber(
          this.contactDetails.phone
        );
      }

      if (
        this.$store.state.cartItem.deliveryTown === undefined ||
        sessionStorage.deliveryTown === undefined ||
        sessionStorage.deliveryTown === "{}"
      ) {
        return;
      }

      let province =
        this.$store.state.cartItem.deliveryTown.province ||
        JSON.parse(sessionStorage.deliveryTown).province;
      province === "Quebec" || province === "Québec"
        ? (this.showLanguageChoice = true)
        : (this.contactDetails.textCommunicationLang = "English");
      //for CBC toggle value always No
      if (
        this.product &&
        this.product.productType.key == "Curated_Bundle" &&
        this.product.sku.endsWith("_ca")
      ) {
        this.isCBCSKuCanadaWide = true;
        this.contactDetails.toggleYes = "No";
      }
      const sameDayTextCutoffDate = this.$dayjs(
        this.getDeliveryDate(),
        "YYYY-MM-DD"
      )
        .tz("America/Winnipeg")
        .subtract(1, "day")
        .hour(12);
      const today = this.$dayjs().tz("America/Winnipeg");

      if (today.isAfter(sameDayTextCutoffDate)) {
        this.isSameDayDelivery = true;
        this.contactDetails.toggleYes = "No";
      }

      if (
        name &&
        !/^\s+$/.test(name) &&
        phone &&
        isPhoneValid &&
        toggleYes &&
        textCommunicationLang &&
        JSON.stringify(this.deliveryWindowSelected) !== "{}"
      ) {
        this.$store.dispatch("cartItem/CONTACT_DETAIL_ADD", {
          ...this.contactDetails,
        });
        // if (this.workflow == "SUBSCRIPTION") {
        //   this.$nuxt.$emit("disableContinueSubs", false);
        // } else {
        //   this.$nuxt.$emit("disableContinue", false);
        // }
        this.$nuxt.$emit("deliveryWindowDisabled", false);
      } else {
        this.$nuxt.$emit("deliveryWindowDisabled", true);
        // if (this.workflow == "SUBSCRIPTION") {
        //   this.$nuxt.$emit("disableContinueSubs", true);
        // } else {
        //   this.$nuxt.$emit("disableContinue", true);
        // }
      }
    },
    getSelectedWindow(window: {
      region_name: string;
      region_code: string;
      zone_rate: string;
      display_text: string;
    }): boolean {
      return (
        this.deliveryWindowSelected.deliveryRegion &&
        window.display_text === this.deliveryWindowSelected.title
      );
    },
    getCuratedSelectedWindow(rate: string) {
      return (
        this.deliveryWindowSelected.deliveryRegion &&
        rate == this.deliveryWindowSelected.title
      );
    },
    async getShopifyDeliveryRateProducts() {
      const productType = "Delivery"; //TODO refactor this logic
      const { data } = await invokeShopifyQuery(
        getDeliveryProductByHandle(productType)
      );
      this.shopifyDeliveryWindows = await this.mapShopifyProducts(data);
    },
    async getDeliveryWindowPara() {
      let addressType = this.$store.state.cartItem.recipient.addressType;
      if (this.isCBCSKuCanadaWide) {
        return this.$t("delivery_window_curated");
      } else if (addressType === "Business" || addressType === "Entreprises") {
        return this.$t("delivery_window_business");
      } else if (addressType === "Hospital" || addressType === "Hôpital") {
        return this.$t("delivery_window_hospital");
      } else if (
        addressType === "Apartment/Complex" ||
        addressType === "Apartment/Complex"
      ) {
        return this.$t("delivery_window_Apartment_Complex");
      } else {
        return this.$t("delivery_window_house");
      }
    },
    getDeliveryWindowTitle(deliveryWindowTitle: any) {
      let subTexts = deliveryWindowTitle.split("(");
      if (subTexts.length > 1) {
        return `${this.$t(subTexts[0].trim())} (${this.$t(
          subTexts[1].replace(")", "").trim()
        )})`;
      } else {
        return `${this.$t(subTexts[0].trim())}`;
      }
    },
    checkForSurcharge(amount, surchargeDates) {
      let priceAmount = amount;
      // update the price with surcharge amount for same day deliveries
      if (
        sessionStorage.getItem("deliveryDate") ===
          this.$dayjs().format("YYYY-MM-DD") &&
        surchargeDates.indexOf(sessionStorage.getItem("deliveryDate")) > -1
      ) {
        priceAmount = parseFloat(priceAmount) + this.pageData.surcharge_amount;
        priceAmount = priceAmount.toFixed(1).toString();
      }

      return priceAmount;
    },
    async setUpDeliveryWindows() {
      // Add new delivery window contact paragraph according to the selected region type (Onfleet or Courier)
      try {
        const page = await butter(this.$config).page.retrieve(
          "*",
          "delivery-window",
          {
            locale: this.$i18n.locale,
            timeout: 10000,
          }
        );
        this.pageData = page?.data.data.fields;
        if (sessionStorage.deliveryTown === undefined) {
          return;
        }
        const selectedRegion = JSON.parse(
          sessionStorage.deliveryTown
        ).regionTag;
        const courierRegions = this.pageData.courier_regions;
        if (
          courierRegions.length > 0 &&
          courierRegions.filter((item) => item.name === selectedRegion).length >
            0
        ) {
          this.deliveryWindowRegionalPara = this.$t(
            "delivery_window_courier_region_para"
          );
        } else {
          this.deliveryWindowRegionalPara = this.$t(
            "delivery_window_onfleet_region_para"
          );
        }
      } catch (error) {
        console.error(error);
      }
      this.postalCode =
        this.postalCode && this.postalCode.length > 0
          ? this.postalCode
          : this.$store.state.cartItem.recipient.postalCode;
      await this.getShopifyDeliveryRateProducts();
      if (this.$store.state.cartItem.recipient.postalCode === undefined) {
        return;
      }
      let postal = this.$store.state.cartItem.recipient.postalCode
        .replace(/\s/g, "")
        .trim()
        .toUpperCase();

      //Workaround for sku change in CBC ordersπre
      if (this.product && !this.product.verif_sku) {
        this.product.verif_sku = this.product.sku;
      }
      const surchargeDates = this.pageData.surcharge_dates;

      if (this.product && this.product.verif_sku?.endsWith("_ca")) {
        try {
          //TODO:: migrate api call to storefront-api
          let firstAvailableDate = this.$dayjs().format("YYYY-MM-DD");
          const payload = await this.$axios.$get(
            `https://zetfwunfcd.execute-api.ca-central-1.amazonaws.com/prod/rates/${postal}?user_date=${firstAvailableDate}`,
            {
              headers: {},
            }
          );
          payload.forEach((element: any) => {
            const shopifyProduct =
              this.shopifyDeliveryWindows[0].productVariants.filter(
                (window: any) => {
                  return (
                    parseFloat(window.price.amount) ===
                    parseFloat(element.price)
                  );
                }
              );
            let deliveryWindow = {
              deliveryRegion: element.city,
              time: element.rate,
              title: element.rate,
              timeView: element.rate,
              price: this.getPriceWithLocale(element.price),
              startDeliveryDate: element.start_date,
              endDeliveryDate: element.end_date,
              productVariant: shopifyProduct[0],
              selected: this.getCuratedSelectedWindow(element.rate),
              pullDate: element.pull_date,
              ratePerDelivery: this.getPriceWithLocale(element.price),
            };

            this.deliveryWindows.push(deliveryWindow);
            // select deliverywindow if there is one delivery window
            if (this.deliveryWindows.length === 1) {
              this.onDeliveryWindowSelect(this.deliveryWindows[0]);
            }
          });
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          this.deliveryRatesLoadingState = {
            loading: true,
            success: false,
            fail: false,
          };
          const payload = await this.$axios.$get(
            `/rates/delivery/postalcode/${postal}/date/${this.getDeliveryDate()}?lang=${this.$i18n.getLocaleCookie()}`,
            {
              headers: {
                "callia-lang": this.$i18n.getLocaleCookie(),
              },
            }
          );
          const finalPayload = JSON.parse(JSON.parse(payload.body)).sort(
            (a: any, b: any) => {
              return (
                Number(a.zone_rate.replace("$", "")) -
                Number(b.zone_rate.replace("$", ""))
              );
            }
          );
          //Same Address Order flow
          let sameAddressDeliveryWindow =
            this.$store.state.cartItem.sameDayDelivery.currSameAddressOrder;
          if (this.isSameAddressOrder && sameAddressDeliveryWindow) {
            let shopifyProduct = this.shopifyDeliveryWindows.find(
              (item) => item.handle === "2-delivery-charge"
            );


            this.deliveryWindows = [];
            this.deliveryRatesLoadingState = {
              loading: false,
              success: true,
              fail: false,
            };
            this.deliveryWindows.push({
              deliveryRegion:
                sameAddressDeliveryWindow.deliveryWindow.deliveryRegion,
              regionCode: sameAddressDeliveryWindow.deliveryWindow.regionCode,
              title: sameAddressDeliveryWindow.deliveryWindow.title,
              timeView: sameAddressDeliveryWindow.deliveryWindow.timeView,
              price: this.getPriceWithLocale(
                shopifyProduct.productVariants[0].price.amount
              ),
              selected: this.getSelectedWindow({
                region_name:
                  sameAddressDeliveryWindow.deliveryWindow.deliveryRegion,
                region_code:
                  sameAddressDeliveryWindow.deliveryWindow.regionCode,
                zone_rate: shopifyProduct.productVariants[0].price.amount,
                display_text: sameAddressDeliveryWindow.deliveryWindow.timeView,
              }),
              productVariant: shopifyProduct.productVariants[0],
            });
          }
          //Regular flow
          else {
            this.deliveryWindows = [];
            this.deliveryWindows = finalPayload
              .map(
                (element: {
                  region_name: string;
                  region_code: string;
                  zone_rate: string;
                  display_text: string;
                }) => {
                  // update the element.zone_rate from surcharge amount
                  const shopifyProduct =
                    this.shopifyDeliveryWindows[0].productVariants.filter(
                      (window: any) => {
                        return (
                          parseFloat(window.price.amount) ===
                          this.checkForSurcharge(
                            element.zone_rate.replace("$", ""),
                            surchargeDates
                          ) *
                            this.subscriptionTimePeriod
                        );
                      }
                    );

                  let ratePerDelivery = `(${element.zone_rate}/delivery)`;

                  this.deliveryRatesLoadingState = {
                    loading: false,
                    success: true,
                    fail: false,
                  };

                  if (shopifyProduct.length > 0) {
                    return {
                      deliveryRegion: element.region_name,
                      regionCode: element.region_code,
                      title: this.getDeliveryWindowTitle(
                        element.display_text.trim()
                      ),
                      timeView: element.display_text,
                      price: this.getPriceWithLocale(
                        shopifyProduct[0].price.amount
                      ),
                      selected: this.getSelectedWindow(element),
                      productVariant: shopifyProduct[0],
                      ratePerDelivery: ratePerDelivery,
                    };
                  }
                }
              )
              .filter((item: any) => item !== undefined);
          }

          // select deliverywindow if there is one delivery window
          if (this.deliveryWindows.length === 1) {
            this.onDeliveryWindowSelect(this.deliveryWindows[0]);
          }
        } catch (error) {
          this.deliveryRatesLoadingState = {
            loading: false,
            success: false,
            fail: true,
          };
          this.deliveryWindows = [];
          console.error(error);
        }
      }
    },
  },
  async fetch() {
    await this.setUpDeliveryWindows();
  },
};
